export const experiences = [
  {
    title: "Full Stack Software Developer",
    company: "Omreon Bilişim Teknolojileri",
    location: "Turkey",
    jobDescription:
    "\n"+
        "AdPlusKobi (Turkcell)\n" +
        "Yaani Self Service (Turkcell)\n" +
        "Kvkk Project Envanter App\n" +
        "As a Full Stack developer, I take part in Turkcell's Add Plus Kobi and Yaani Self Service applications. I also take part in Omreon own application, Envanter. I mostly do backend enhancements and bug fixes as well as moderate frontend development.",
    startDate: "10/2022",
    endDate: "present",
  },
  {
    title: "Back-end Developer",
    company: "Netmera",
    location: "Turkey",
    jobDescription:
      "As part of the Kanban team, I take part in the development of Netmera web products. As a back-end developer, I develop new features for web products. I write various unit tests for the features I'm developing. Technologies I actively use; Java, Spring Boot, JUnit, MongoDB, MySQL, Restful Web Services, Git.",
    startDate: "05/2022",
    endDate: "10/2022",
  },
  {
    title: "Software Developer Intern",
    company: "Netmera",
    location: "Turkey",
    jobDescription:
      "During the three-month internship program, I had the opportunity to learn about business development processes and how a software product is developed. I actively used Java and Spring Boot technologies. I enjoyed making new feature additions and bug fixes.",
    startDate: "02/2022",
    endDate: "04/2022",
  },
];
